export const ALERT_TEXT = 'A new code has been sent to your email';
export const CHECK_YOUR_EMAIL = 'We just emailed you a six-digit code to: ';
export const KEEP_WINDOW_OPEN = 'Please enter the code below';
export const LIMIT_EXCEEDED =
  'Attempt limit exceeded, please try again after some time.';
export const WELCOME_HEADER = 'Verify Account';

export const WELCOME_SUB_HEADER = 'Check your email';
